import VueLazyload from 'vue-lazyload';
import { S3_BUCKET_URL } from '@/constants';
import { getCloudinaryUrl } from '@/services/asset';

const hasCloudinarySrc = (src: string = '') => (
  src.includes('pleatt-assets.s3')
);

export default (instance: any) => {
  instance.use(VueLazyload, {
    adapter: {
      error(listener: any) {
        // set lazy attribute to loaded as
        // cloudinary images fallback to s3 bucket
        hasCloudinarySrc(listener.src)
          && listener.error.includes(S3_BUCKET_URL)
          && listener.el.setAttribute('lazy', 'loaded');
      },
    },
    filter: {
      cloudinary(listener: any) {
        const { el, src } = listener;
        if (!hasCloudinarySrc(src)) {
          return;
        }
        // find which width to load based on DOM size
        // use cloudinary src or fallback to original url
        const elementWidth = el.clientWidth;
        listener.error = src;
        listener.src = getCloudinaryUrl(src, elementWidth);
      },
    },
  });
};
